import React, { useContext, useState, useEffect } from 'react'
import { getImages } from '../Component/const'
import SortingTable from '../Component/VehicleAnalysis/SortingTable'
import { VehicleContext } from '../Component/Context/VehicleContext';
import ModalLayout from '../Component/Common/ModalLayout'
import LoadingModal from '../Component/Common/LoadingModal'
import PerfectMatchModal from '../Component/PerfectMatch/PerfectMatchModal';
import FitAnalysisModal from '../Component/VehicleAnalysis/FitAnalysisModal';
import Switch from '../Component/PriceMismatch/Switch';
import { Form, Formik } from 'formik';

const EditableField = ({ label, initialValue }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(initialValue);
    const handleEditClick = () => {
        setIsEditing(true);
    };
    const handleChange = (e) => {
        setValue(e.target.value);
    };
    const handleBlur = () => {
        setIsEditing(false);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            setIsEditing(false);
        }
    };
    return (
        <div className='col-md-4 py-1'>
            <div className='cb-label text-center pe-4 fw-200'>{label}</div>
            <div className='md-title font-18 mt-2 text-center'>
                {isEditing ? (
                    <input
                        type='text'
                        value={value}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        onKeyDown={handleKeyDown}
                        autoFocus
                    />
                ) : (
                    <>{value} <button type='button' className='edit-btn' onClick={handleEditClick}><img src={getImages('edit-material.svg')} alt='Edit' /></button></>
                )}
            </div>
        </div>
    );
};
const VehicleAnalysis = () => {

    const { getDealershipMatch, validateVIN, getFitAnalysis, dealershipMatchSave } = useContext(VehicleContext);

    const [loadingPage, setLoadingPage] = useState(false);

    const [vinText, setVinText] = useState("");
    const [mileageText, setMileageText] = useState("");
    const [priceText, setPriceText] = useState("");
    //console.log("vinText", vinText)
    //console.log("mileageText", mileageText)
    //console.log("priceText", priceText)
    const [dealershipData, setDealershipData] = useState({});   

    const [sortedDealershipData,setSortedDealershipData] = useState({});

    const [scoreOrder,setScoreOrder] = useState(false);

    const queryParameters = new URLSearchParams(window.location.search)
    const vinParam = queryParameters.get("vin");
    const mileageParam = queryParameters.get("mileage");
    const priceParam = queryParameters.get("price");

    const getDealershipData = async (vin, mileage = null, price = null) => {

        if (validateVIN(vin)) {
            setLoadingPage(true);

            var values = { 'vin': vin };

            if (mileage) values.mileage = mileage;
            if (price) values.price = price;

            const data = await getDealershipMatch(values);

            setDealershipData(data);

            setSortedDealershipData(data.dealership_counts);

            setLoadingPage(false);

            setScoreOrder(data.has_saved_rankings);
        }
    }

    useEffect(() => {
        console.log("useEffect parameters", vinText);
        setVinText(vinParam ?? "");
        setMileageText(mileageParam ?? "");
        setPriceText(priceParam ?? "");

        getDealershipData(vinParam, mileageParam, priceParam);
    }, [vinParam, mileageParam, priceParam]);

    const [openFilterModal, setOpenFilterModal] = useState(false);
    const handleFilter = () => {
        setOpenFilterModal(true)
    }
    const closeHandleFilter = () => {
        setOpenFilterModal(false)
    }

    // Fit Analysis Modal

    const [fitAnalysisData, setFitAnalysisData] = useState([]);

    const [openFitAnalysisModal, setOpenFitAnalysisModal] = useState(false);
    const handleFitAnalysisModal = async (dealership, location, transactions) => {

        const values = { 'year': dealershipData.vin_info.year_is, 'make': dealershipData.vin_info.make_ss, 'model': dealershipData.vin_info.model_ss, 'trim': dealershipData.vin_info.trim_ss, 'seller_name_ss': dealership };

        setLoadingPage(true);

        const data = await getFitAnalysis(values);

        setLoadingPage(false);

        console.log(data);

        setFitAnalysisData({ ...data, 'dealership': dealership, 'mileage': mileageText, 'price': priceText, 'location': location, 'transactions': transactions });

        setOpenFitAnalysisModal(true);
        document.body.classList.add('overflow-active');
    }
    const closeFitAnalysisModal = () => {
        setOpenFitAnalysisModal(false)
        document.body.classList.remove('overflow-active');
    }

    // For Tab View
    const [isTabView, setIsTabView] = useState(window.innerWidth < 991);
    useEffect(() => {
        const handleResize = () => {
            setIsTabView(window.innerWidth < 991);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Fit Analysis Modal
    const [openVehicleDetailsModal, setOpenVehicleDetailsModal] = useState(false);
    const handleMebtn = () => {
        setOpenVehicleDetailsModal(true);
    }
    const closeVehicleDetailsModal = () => {
        setOpenVehicleDetailsModal(false);
    }


    // Search Text Modal
    const [searchText, setSearchText] = useState("");
    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };
    // useEffect(() => {
    //     setFindDealership(!dealership);
    // }, [dealership]);

    const getSortedData = (sortedData) => {
        setSortedDealershipData(sortedData);
    }

    const saveScores = () => {
        const values = {'vin':vinText,'dealerships':sortedDealershipData.map(dealer => dealer.name)};
        dealershipMatchSave(values);
    }

    return (
        <>
            {loadingPage &&
                <ModalLayout open={loadingPage} modalWidth={550} darkThemeCls="true">
                    <LoadingModal />
                </ModalLayout>
            }
            {/* {console.log("dealershipData", dealershipData)} */}
            <div className='main-card'>
                <div className='mob-va-block'>
                    <form className="custom-form chatbox-form" autoComplete="off" name="contact-form">
                        <div className='row filter-block custom-form'>
                            <div className='col-md-8 col-8'>
                                <div
                                    className={`mob-custom-modal ms-auto ${openVehicleDetailsModal ? "open" : ""}`}
                                >
                                    <div className="d-flex d-lg-none align-items-center justify-content-between mob-custom-header w-100">
                                        <div className="mob-header-title">Contact Info</div>
                                        <div>
                                            {/* <button className="sm-box-close mt-0" type="button" onClick={() => backToResultBtn(index)}> */}
                                            <button className="sm-box-close mt-0" type="button"
                                                onClick={closeVehicleDetailsModal}
                                            >
                                                <img src={getImages('white-close.svg')} alt="Close" />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="mob-custom-body">
                                        <div className='row'>
                                            {!isTabView && (
                                                <>
                                                    <div className='col-md-5'>
                                                        <label className='cs-label'>VIN Number</label>
                                                        <div className={`d-flex align-items-center vin-flex ${'full-width'}`}>
                                                            <input
                                                                type='text'
                                                                name='vin'
                                                                className='form-control text-uppercase'
                                                                placeholder=''
                                                                value={vinText}
                                                                onChange={(e) => { setVinText(e.target.value) }}
                                                            />
                                                            {!loadingPage && (
                                                                <button type='button' className='red-btn text-center' onClick={() => getDealershipData(vinText)}>
                                                                    <img src={getImages('white-check-icon.svg')} alt='check-icon' />
                                                                </button>
                                                            )}
                                                        </div>
                                                        {/* <div className='ext-sm-title text-start mt-1'>Tip: Enter VIN and we'll pre-fill the rest for you.</div> */}
                                                        {dealershipData && 'vin_info' in dealershipData ? (
                                                            <div className="xs-title font-15 mt-md-2">
                                                                {dealershipData.vin_info.year_is} {dealershipData.vin_info.make_ss} {dealershipData.vin_info.trim_ss} {dealershipData.vin_info.model_ss}
                                                                <img style={{ verticalAlign: "-2px" }} className='ms-2' src={getImages('check-material.svg')} />
                                                            </div>
                                                        ) : ''}
                                                    </div>
                                                </>
                                            )}
                                            <div className='col-lg-3 col-12 mb-lg-0 mb-4'>
                                                <label className='cs-label'>Miles</label>
                                                <input type='text' name='miles' className='form-control' value={mileageText}
                                                    onChange={(e) => { setMileageText(e.target.value) }} />
                                            </div>
                                            <div className='col-lg-3 col-12'>
                                                <label className='cs-label'>Price</label>
                                                <input type='text' name='price' className='form-control' value={priceText}
                                                    onChange={(e) => { setPriceText(e.target.value) }} />
                                            </div>
                                            {isTabView ?
                                                (
                                                    <div className="mt-auto d-lg-none text-center mob-action-pos">
                                                        <button type="button" className="red-btn text-uppercase w-100">Go</button>
                                                    </div>
                                                )
                                                : (
                                                    <>
                                                        <div className='col-md-1'>
                                                            <label className='cs-label'>&nbsp;</label><br />
                                                            <button type='button' className='red-btn sm-btn text-uppercase vinred-btn'>Go</button>
                                                        </div>
                                                    </>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                {isTabView && (
                                    <>
                                        <div className='md-title text-uppercase fw-700 font-1-8em'>Perfect Match</div>
                                        <div className='xs-title font-14 text-uppercase text-red mt-1'>By Experience Wholesale</div>
                                    </>
                                )}
                            </div>

                            <div className='col-md-4 col-4 text-end'>
                                <div className='d-flex'>
                                    <div className='ms-auto'>
                                        {/* <Switch name="oem_dealer" label="Dealer Mismatch" value="yes"/> */}
                                        <label className='cs-label mb-3'>&nbsp;</label><br />
                                        <div className='d-flex'>
                                            <div className=" d-flex align-items-center">
                                                <label className="custom-switch">
                                                    <input type="checkbox" checked={scoreOrder} name="order" onChange={(e) => setScoreOrder(!scoreOrder)} disabled={!dealershipData.has_saved_rankings}/>
                                                    <span className="slider"></span>
                                                </label>
                                            </div>
                                            <div className='ms-2 xs-title font-15 fw-400'>Re-order Score</div>
                                        </div>
                                    </div>
                                    <div className='ms-3'>
                                        <div><img className='chip-icon' src={getImages('chip-ai.svg')} alt='chip' /></div>
                                        <div className='xs-title font-12 mt-2 text-nowrap'>Powered by AI</div>
                                    </div>
                                </div>
                            </div>
                            {isTabView && (
                                <>
                                    <div className='col-12 mb-3 mt-4'>
                                        <div className='d-flex align-items-center justify-content-between mb-1'>
                                            <label className='cs-label mb-0'>VIN Number</label>
                                            <button type='button' className='manual-entry-btn' onClick={handleMebtn}>Manual Entry</button>
                                        </div>
                                        <div className={`d-flex align-items-center vin-flex ${'full-width'}`}>
                                            <input
                                                type='text'
                                                name='vin'
                                                className='form-control text-uppercase'
                                                placeholder=''
                                                value={vinText}
                                                onChange={(e) => { setVinText(e.target.value) }}
                                            />
                                            {!loadingPage && (
                                                <button type='button' className='red-btn text-center' onClick={() => getDealershipData(vinText)}>
                                                    <img src={getImages('white-check-icon.svg')} alt='check-icon' />
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className='col-8'>
                                        {dealershipData && 'vin_info' in dealershipData ? (
                                            <div className="xs-title font-15 mt-lg-2">
                                                {dealershipData.vin_info.year_is} {dealershipData.vin_info.make_ss} {dealershipData.vin_info.trim_ss} {dealershipData.vin_info.model_ss}
                                                <img style={{ verticalAlign: "-2px" }} className='ms-2' src={getImages('check-material.svg')} />
                                            </div>
                                        ) : ''}
                                    </div>
                                    <div className='col-4 text-end'>
                                        <button type='button' className='pm-filter-btn' onClick={handleFilter}><img src={getImages('filter-font-awesome.png')} /> Filters</button>
                                    </div>
                                    <div className='col-4 text-end'>
                                        <button type='button' className='pm-filter-btn' onClick={handleFilter}><img src={getImages('filter-font-awesome.png')} /> Filters</button>
                                    </div>
                                </>
                            )}
                            {/* <div className='ext-sm-title text-start mt-1'>Tip: Enter VIN and we'll pre-fill the rest for you.</div> */}

                        </div>
                    </form>
                </div>
                <div className='match-dealer-box'>
                    {!isTabView && (
                        <>
                            <div className='mb-3'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div>
                                        <span className='md-title text-uppercase font-1-8em fw-700'>Perfect Match</span>
                                        <div className="tooltip-container info-msg">
                                            <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                            <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <div className='d-flex align-items-center'>
                                            <div className='pf-cs-label me-3'>Manual Winner Entry</div>
                                            <div className='pf-search-flex position-relative'>
                                                <div className='search-flex w-100 me-5'>
                                                    <input type='text' className='form-control' placeholder='Search' value={searchText} onChange={handleSearchChange} />
                                                </div>
                                                {searchText&&
                                                <ul className='fdm-list'>
                                                    {console.log("dealershipData.dealership_counts", dealershipData.dealership_counts)}
                                                    {dealershipData.dealership_counts && dealershipData.dealership_counts.length > 0 ? (
                                                        dealershipData.dealership_counts
                                                            .filter(item =>
                                                                !searchText ||
                                                                (item.name && item.name.toLowerCase().includes(searchText.toLowerCase())) ||
                                                                (item.email && item.email.toLowerCase().includes(searchText.toLowerCase()))
                                                            )
                                                            .slice(0, 100)
                                                            .map((item, index) => (
                                                                <li key={index}>
                                                                    <a
                                                                        href={`/dealer-analysis?dealership=${encodeURIComponent(item.name)}`}
                                                                        className='d-flex align-items-center justify-content-between'
                                                                    >
                                                                        <div className='fd-title'>{item.name}</div>
                                                                        <div className='fd-email'>{item.email}</div>
                                                                    </a>
                                                                </li>
                                                            ))
                                                    ) : (
                                                        <li className="text-muted">No results found</li>
                                                    )}
                                                </ul>
                                                }
                                            </div>
                                        </div>
                                        <div className='me-5'>
                                            <button type='button' className='pm-filter-btn' onClick={handleFilter}><img src={getImages('filter-font-awesome.png')} /> Filters</button>
                                        </div>
                                        <div >
                                            <button type='button' className='pm-filter-btn' onClick={saveScores}>Save</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {dealershipData && 'dealership_counts' in dealershipData &&
                        <SortingTable
                            dealershipData={dealershipData}
                            handleFitAnalysisModal={handleFitAnalysisModal}
                            isTabView={isTabView}
                            getSortedData={getSortedData}
                            scoreOrder={scoreOrder}
                        />
                    }
                </div>
            </div>
            <ModalLayout open={openFilterModal} modalWidth={1140} darkThemeCls="true">
                <PerfectMatchModal isTabView={isTabView} close={closeHandleFilter} />
            </ModalLayout>
            {openFitAnalysisModal &&
                <ModalLayout
                    open={openFitAnalysisModal}
                    close={closeFitAnalysisModal}
                    modalWidth={900}
                    darkThemeCls="true"
                    pmFilterModal="fit-analysis-modal"
                >
                    <FitAnalysisModal
                        close={closeFitAnalysisModal}
                        data={fitAnalysisData}
                    />
                </ModalLayout>
            }
        </>
    )
}

export default VehicleAnalysis